export default {
  namespaced: false,
  state: {
    statusOptions:{
    },
    messageOptions:{
    },
    confirmOptions:{},
  },
  actions:{
    showStatus({commit},options){
      commit("setStatusOptions",options);
    },
    showMessage({commit},options){
      commit("setMessageOptions",options);
    },
    showConfirm({commit},options){
      commit("setConfirmOptions",options);
    },
  },
  mutations: {
    setStatusOptions(state,options){
      state.statusOptions = options;
    },
    setMessageOptions(state,options){
      state.messageOptions = options;
    },
    setConfirmOptions(state,options){
      state.confirmOptions = options;
    },
  },
}